/* unplugin-vue-components disabled */import { render } from "./SelectWall.vue?vue&type=template&id=bff22b04&scoped=true&ts=true"
import script from "./SelectWall.vue?vue&type=script&lang=ts"
export * from "./SelectWall.vue?vue&type=script&lang=ts"

import "./SelectWall.vue?vue&type=style&index=0&id=bff22b04&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bff22b04"]])

export default __exports__